import _ from 'lodash';

class ItemsController {
  /*@ngInject*/
  constructor(Auth, $state, User, $translate, $location, $q, Modal, $scope, TransactionService, SetupService, ShipmentService, DateUtil,
              RouteService, $stateParams, DataCounter, HoldService, Navigation, UsersService, $window, TimezoneList, LocationService,
              CommonLayoutService, $rootScope) {
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.$scope = $scope;
    this.Modal = Modal;
    this.$q = $q;
    this.TransactionService = TransactionService;
    this.SetupService = SetupService;
    this.ShipmentService = ShipmentService;
    this.DateUtil = DateUtil;
    this.RouteService = RouteService;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.DataCounter = DataCounter;
    this.HoldService = HoldService;
    this.Navigation = Navigation;
    this.UsersService = UsersService;
    this.$window = $window;
    this.TimezoneList = TimezoneList;
    this.LocationService = LocationService;
    this.CommonLayoutService = CommonLayoutService;
    this.$rootScope = $rootScope;

    this.model = {
      search: "",
      branch: User.getUser().branchId,
      stats: "itemStatus",
      isSentToHold: false,
      timezone: null,
      timezoneList: this.TimezoneList.getTimezoneList()
    }

    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: 10,
      maxPages: 10
    };

    this.stats = {
      itemStatus: 'itemStatus',
      itemHistory: 'itemHistory'
    }

    this.sortOrder = {
      fieldName: 'transactionDate',
      order: 'DESC'
    }

    this.transactionData = [];
    this.trackingIdData = [];
    this.lastScanned = "";
    this.valutDate = "";
    this.itemStatus = [];
    this.shipmentData = {};
    this.newUrl = "";
    this.trackingIdBranch = "";
    this.isAllowedToUnpack = false;
    this.userDetails = this.User.getUser();
    this.loggedInUser = this.User.getUser().id;
    this.customerId = this.User.getUser().customerUser ? this.User.getUser().customerId : null;
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/shipment-history');
    this.selectedDepositAmountValue = "totalAmount";
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};
    const permissionsToCheck = ['branch_mgmt_items'];

    permissionsToCheck.forEach((permissionKey) => {
      this.acl[permissionKey] = this.User.getACL(permissionKey);

      this.hasACL[permissionKey] = {};

      this.acl[permissionKey].forEach((permission) => {
        this.hasACL[permissionKey][permission] = true;
      });
    });
    this.hasBranchMgmtItemsEditPermission = this.hasACL['branch_mgmt_items']['edit'];
  }

  $onInit() {
    this.$q.all([
      this.SetupService.get(this.model.branch),
      this.UsersService.getUserFieldData(this.loggedInUser),
      this.getSoftDeleteShipmentPermission()
    ])
      .then((data) => {
        this.valutDate = this.DateUtil.convertToDate(data[0].currentVaultDate);
        this.branchInfo = data[0];
        this.model.userdetails = data[1];
        this.model.timezone = this.model.userdetails.timezone ? this.model.userdetails.timezone : moment.tz.guess();
      })
      .then(() => {
        this.loadPermission();
        this.loadItemHistory();
      })
      .catch((err) => {
        console.log(err)
      })

    this.model.errorMsg = this.$translate.instant('error.branch_mgmt.items_not_display');
    this.model.noItemDisplay = true;
  }

  loadItemHistory() {
    let dataCounter = this.DataCounter.getData();
    if (this.$stateParams.id) {
      this.model.search = this.$stateParams.id;
      this.loadData();
    }
    else if (dataCounter && dataCounter.trackingId && dataCounter.isRedirected) {
      this.model.search = dataCounter.trackingId;
      this.loadData();
      this.DataCounter.setData();
    }
    else {
      this.model.search = "";
    }
  }

  print() {
    setTimeout(() => window.print(), 100);
  }

  pageChange() {
    this.getTransactionHistory()
  }

  tabSelection(selectedValue) {
    this.model.stats = selectedValue;
  }

  replaceURL() {
    this.$state.transitionTo('branchManagement.items', { id: this.model.search })
    // this.$state.transitionTo('branchManagement.items', { id: "" }, { reload: false })
  }

  generateSearchObj() {
    const searchObj = {
      queryJSON: {
        rules: [{
          field: 'trackingId',
          condition: '=',
          data: this.model.search
        }],
        operator: 'AND'
      },
      order: {
        fieldName: this.sortOrder.fieldName,
        keyword: this.sortOrder.order
      }
    };
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }

  getTransactionHistory() {
    // const searchObj = this.generateSearchObj();

    if (this.model.search == '') {
      return;
    }

    if (this.lastScanned && (this.model.search != this.lastScanned)) {
      delete this.msg
      delete this.branchTransferMsg;
      delete this.shipmentDeliveredMsg;
      delete this.updateTrackingIdMsg;
      this.pagination.page = 1;
    }

    this.model.loading = true;
    return this.TransactionService.transactionHistory(this.model.search, this.pagination.pageLimit, (this.pagination.page - 1) * this.pagination.pageLimit)
      .then((data) => {
        if (data.results.length) {
          this.lastScanned = this.model.search;
          this.pagination.total = data.total;
          this.pagination.loading = false;
          this.shipments = data.results;
          this.depositRecord = data.depositRecord;
          
          if (this.depositRecord) {
            this.depositPopover = (`
              <div><b>Stated Value</b>: ${this.formatAmount(this.depositRecord.statedTotalAmount)}</div>
              <div><b>Declared Value</b>: ${this.formatAmount(this.depositRecord.declaredTotalAmount)}</div>
              <div><b>Counted Value</b>: ${this.formatAmount(this.depositRecord.totalAmount)}</div>
              <div><b>Counted Variance</b>: ${this.formatAmount(this.depositRecord.countedVariance)}</div>
          `)
          }

          this.model.isError = false;
          this.model.noItemDisplay = false;
          // this.model.vaultCloseDetails = data.vaultCloseInfo;
          this.getLocalTime();
          // this.findVaultDate();
          // this.localDateTime = moment(this.valutDate).format('MM-DD-YYYY');
        }
        else {
          // this.model.isError = true;
          // this.model.search = '';
          // this.model.message = this.$translate.instant('error.branch_mgmt.items_id_not_found');
          this.shipments = [];
        }
      })
      .catch((err) => {
        console.log(err);
        this.error = err.message;
      })
      .finally(() => {
        this.model.loading = false;
      });
  }

  // redirect to item hold screen
  itemHold(trackingId) {
    if (trackingId) {
      this.$state.go('branchManagement.itemHolds', {
        trackingId: trackingId,
      });
    }
  }

  isCustomerLocation(trackingId) {
    if (!this.customerId) {
      return Promise.resolve(true);
    }
    return this.ShipmentService.hasCustomerShipment(trackingId, this.customerId, this.model.branch)
    .then(() => Promise.resolve(true))
    .catch(err => {
      this.itemStatus = [];
      this.shipments = [];
      this.pagination.total = 0
      this.shipmentData = {};
      this.model.loading = false;
      if (err && err.data && err.data.message) {
         this.Modal.errorModal( err.data.message);
      }
      return Promise.resolve(false)
    })
  }

  getItemStatus() {

    if (this.model.search == '') {
      return;
    }

    const defer = this.$q.defer();
    this.model.loading = true;
    this.isCustomerLocation(this.model.search)
      .then((allow) =>{
        if (allow) {
          return this.ShipmentService.getItemStatus(this.model.search)
        }
      })
      .then((data) => {
        this.trackingIdBranch = data.branchId;
        this.isLoadShipmentCheckedOut = data.isLoadShipmentCheckedOut;
        this.isResidualshipmentCheckedIn = data.isResidualshipmentCheckedIn;
        this.depositedAt = data.depositedAt;
        if (data.results.length) {
          this.itemStatus = data.results;
          this.shipmentData = {
            branchId: this.itemStatus[0].branchId,
            trackingId: this.itemStatus[0].trackingId,
            routeId: this.itemStatus[0].routeId,
            toLocationId: this.itemStatus[0].toLocationId,
            date: this.itemStatus[0].vaultDate,
            status: this.itemStatus[0].status,
            isOnHold: this.itemStatus[0].holdFlag,
            isDeleted: this.itemStatus[0].deleted,
            isLoadShpDelivered: this.itemStatus[0].isLoadShpDelivered,
            isResidualShpCheckedIn: this.itemStatus[0].isResidualShpCheckedIn,
            isDelivered: this.itemStatus[0].isDelivered,
            checkedIn: this.itemStatus[0].checkedIn,
            pending: this.itemStatus[0].pending,
            shipmentId: this.itemStatus[0].shipmentId,
            denominationId: this.itemStatus[0].denominationId,
            orderNo: this.itemStatus[0].orderNo,
            packedFlag: this.itemStatus[0].packedFlag,
            checkedOut: this.itemStatus[0].checkedOut,
            orderType: this.itemStatus[0].orderType,
            translatedStatus: this.$translate.instant(this.itemStatus[0].status),
            amount: this.itemStatus[0].amount,
            bagSeal: this.itemStatus[0].bagSeal,
            isBagoutDelivered: this.itemStatus[0].isBagoutDelivered,
            bagoutDeliveryImageName: this.itemStatus[0].bagoutDeliveryImageName,
            bagoutDeliveryDate: this.itemStatus[0].bagoutDeliveryDate,
            bagoutSignatureFirstName: this.itemStatus[0].bagoutSignatureFirstName,
            bagoutSignatureLastName: this.itemStatus[0].bagoutSignatureLastName,
            pickupFlag: this.itemStatus[0].pickupFlag,
            unpackAnyTime: this.itemStatus[0].unpackAnyTime,
            fundingSourceId: this.itemStatus[0].fundingSourceId,
            packedDate: this.itemStatus[0].packedDate,
            coinFlag: this.itemStatus[0].coinFlag,
            coinDebited: this.itemStatus[0].coinDebited,
            isRequiredPickup: this.itemStatus[0].isRequiredPickup,
            shipmentCheckedIn: this.itemStatus[0].shipmentCheckedIn,
            deliveryDate: this.itemStatus[0].deliveryDate,
            fromLocationType: this.itemStatus[0].fromLocationType,
            fromLocationId: this.itemStatus[0].fromLocationId,
            fromLocationName: this.itemStatus[0].fromLocationName,
            toLocationName: this.itemStatus[0].toLocationName,
            toLocationType: this.itemStatus[0].toLocationType,
            loadedAmount: this.itemStatus[0].loadedAmount,
            routeName: this.itemStatus[0].routeName,
            receivedByName: this.itemStatus[0].receivedByName,
            vaultDate: this.itemStatus[0].vaultDate,
            fromLocationEmail: this.itemStatus[0].fromLocationEmail,
            toLocationEmail: this.itemStatus[0].toLocationEmail,
            shiptype: this.itemStatus[0].shiptype,
            countCompletedAt: this.itemStatus[0].countCompletedAt,
            countStartedAt: this.itemStatus[0].countStartedAt,
            isParentDelivery: this.itemStatus[0].isParentDelivery,
            packableOrderShipmentId: this.itemStatus[0].packableOrderShipmentId,
            canConvertToCRV: this.itemStatus[0].canConvertToCRV,
            shiptypeId: this.itemStatus[0].shiptypeId,
            individuallyDeliverable: this.itemStatus[0].individuallyDeliverable,
            individuallyDeliverableVaultDate: this.itemStatus[0].individuallyDeliverableVaultDate,
            individuallyDeliverableRouteId: this.itemStatus[0].individuallyDeliverableRouteId,
            isPackableOrder: this.itemStatus[0].isPackableOrder,
            packedAt: this.itemStatus[0].packedAt,
            packableOrderShipmentTrackingIds: this.itemStatus[0].packableOrderShipmentTrackingIds,
            coinDebited: this.itemStatus[0].coinDebited,
            isPackableOrder: data.CODOrdersMetrics.isPackableOrder,
            totalCODCoinsOnRoute: data.CODOrdersMetrics.totalCODCoinsOnRoute,
            isCoinDebited: data.CODOrdersMetrics.isCoinDebited,
            isBulkInventoryOn: data.CODOrdersMetrics.isBulkInventoryOn,
            isDebitBulkCoinOnPack: data.CODOrdersMetrics.isDebitBulkCoinOnPack
          };
          this.model.noItemDisplay = false;
          this.model.isSentToHold = false;
          this.model.loading = false;
          this.isError = false;
          this.model.message = '';
          this.getLocalTime();
        }
        else {
          this.noDataFound = this.$translate.instant('error.branch_mgmt.items_id_not_found');
          this.isError = true;
          this.itemStatus = [];
        }
        defer.resolve(this.trackingIdBranch);
      })
      .catch((err) => {
        this.itemStatus = [];
        this.shipments = [];
        this.pagination.total = 0
        this.shipmentData = {};
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal("error." + err.data.message);
        }
      })
      .finally(() => {
        this.model.loading = false;
      });
    return defer.promise;
  }

  getLocalTime() {
    // this.localDate = moment.utc().toDate();
    // this.localDateTime = moment(this.localDate).format('l h:mm A');
    return moment.utc().format()
  }

  getOrderType(shiptype, orderType) {
    if (shiptype == "C" && orderType !== null) {
      return this.$translate.instant('atm_residual.order_type_' + orderType);
    }
    else if (shiptype == "C" && orderType == null) {
      return shiptype.toUpperCase();
    }
    else {
      return shiptype.toUpperCase();
    }
  }

  loadData() {

    if (this.model.search == '') {
      return;
    }

    this.getItemStatus()
      .then((trackingIdBranch) => {
        this.getTransactionHistory();
          this.shipments = [];
          this.model.isError = true;
          if (!this.trackingIdBranch) this.model.message = this.$translate.instant('error.branch_mgmt.items_id_not_found');
        this.validateOrderPackingUndo();
      })
  }

  sendToHold() {
    const reason = '', comments = 'send to hold';
    const defer = this.$q.defer();

    const holdShipment = (supId = null) => {
      this.ShipmentService.holdShipment(this.shipmentData.branchId, this.shipmentData.trackingId, this.shipmentData.routeId, this.shipmentData.date, supId ? supId : this.loggedInUser, reason, comments)
        .then(() => {
          delete this.updateTrackingIdMsg;
          this.model.isSentToHold = true;
          this.msg = this.$translate.instant('branch_mgmt.itemhistory.reRelease');
          defer.resolve();
        })
        .catch((err) => {
          this.model.isSentToHold = false;
          if (err && err.data && err.data.message) {
            this.Modal.errorModal("error." + err.data.message);
          }
          defer.reject();
        });
    };

    if (this.branchInfo.supervisorScan) {
      this.Modal.confirmSupervisor('send-to-hold', { trackingId: this.shipmentData.trackingId }, ({ modal, supId }) => {
        holdShipment(supId);
        modal.close();
      }, ({ modal }) => {
        modal.close();
      });
    } else {
      this.Modal.confirm({
        header: this.$translate.instant('branch.confirm'),
        message: this.$translate.instant('item.confirm_hold_message', { lable: this.shipmentData.trackingId }),
        callback: (({
          modal
        }) => {
          holdShipment();
          modal.close();
        }),
        type: 'success'
      })
    }
    return defer.promise.then(() => this.loadData());
  }

  // Release item from HOLD
  releaseItem() {
    this.date = "";
    this.routeId = "";

    const defer = this.$q.defer();
    this.UsersService.checkSupervisor(this.loggedInUser)
      .then((userInfo) => {
        this.Modal.holdReleases(this.shipmentData, !userInfo.supervisor, ({ supervisorId, comment, shipmentAssignedTo, selectedDate, routeInfo, modal }) => {
          if (selectedDate) {
            const d = new Date(selectedDate);
            const yearLocal = d.getFullYear();
            const monthLocal = d.getMonth() + 1;
            const dayLocal = d.getDate();
            const pad = (v) => (v < 10 ? '0' + v : '' + v);

            this.date = `${yearLocal}-${pad(monthLocal)}-${pad(dayLocal)}`;
          } else {
            this.date = '';
          }
          this.routeId = shipmentAssignedTo;

          this.ShipmentService.holdRelease(this.shipmentData.trackingId, this.shipmentData.routeId, shipmentAssignedTo, this.date, userInfo.supervisor ? userInfo.id : supervisorId, comment, this.shipmentData.branchId)
            .then((data) => {
              const totals = this.DataCounter.getCounterForItemHold();
              if (totals > 0 && this.shipmentData.isOnHold) this.DataCounter.setCounterForItemHold(totals - 1);
              modal.close();
              defer.resolve();
            })
            .catch((err) => {
              modal.close();
              if (err && err.data && err.data.message) {
                return this.Modal.errorModal("error." + err.data.message);
              }
            })
        }, ({ modal }) => {
          if (modal) modal.close();
        });
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
    defer.promise.then(() => {
      return this.releaseRoute(this.routeId, this.date)
    })
  }

  releaseRoute(route, date) {
    this.RouteService.releaseRoute(route, date)
      .then(() => {
        delete this.branchTransferMsg;
        delete this.updateTrackingIdMsg;
        delete this.msg;
        return this.loadData();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal("error." + err.data.message);
        }
      })
  }

   branchTransfer() {
    if ((this.shipmentData.status === 'shipment.bagout' || this.shipmentData.status === 'shipment.deposited') || (this.shipmentData.shiptypeId === "BULKCASH" && this.shipmentData.bagSeal !== null)) {
      this.model.errorMsg = this.$translate.instant('error.branch_transfer_not_display', {
        bagSeal: this.shipmentData.bagSeal
      })
      return this.Modal.errorModal(this.model.errorMsg);
    }

    const defer = this.$q.defer();
    this.Modal.branchTransferModal(this.shipmentData, ({ modal: branchTransferModal, selectedBranch, comment, supervisorId, selectedRoute , selectedDate, fromBranchId}) => {

      if (this.shipmentData.isPackableOrder && this.shipmentData.packedAt && 
          this.shipmentData.packableOrderShipmentTrackingIds && this.shipmentData.packableOrderShipmentTrackingIds.split(',').length > 1) {
        this.Modal.confirm({
          header: 'Confirm COD Order Transfer',
          message: `Are you sure you want to transfer all shipments <b>(${this.shipmentData.packableOrderShipmentTrackingIds})</b> for this order?`,
          callback: ({ modal }) => {
            modal.close();
            this.shipmentBranchTransfer(selectedBranch, supervisorId, comment, selectedRoute, selectedDate, fromBranchId, branchTransferModal, defer);
          },
          negative: ({ modal }) => {
            modal.close();
          }
        }, ({ modal }) => {
          if (modal) modal.close();
        });
      }
      else {
        this.shipmentBranchTransfer(selectedBranch, supervisorId, comment, selectedRoute, selectedDate, fromBranchId, branchTransferModal, defer);
      }

    }, ({ branchTransferModal }) => {
      branchTransferModal.close();
    })
    defer.promise.then(() => {
      return this.loadData()
    })
  }

  shipmentBranchTransfer(selectedBranch, supervisorId, comment, selectedRoute, selectedDate, fromBranchId, modal, defer) {
    this.ShipmentService.branchTransfer(selectedBranch, this.shipmentData.trackingId, this.shipmentData.routeId,
      this.shipmentData.date, supervisorId, comment, selectedRoute, selectedDate, fromBranchId)
      .then((data) => {
        delete this.msg;
        delete this.updateTrackingIdMsg;
        this.branchTransferMsg = this.$translate.instant('branch_mgmt.itemhistory.branchTransferred');
        defer.resolve();
        modal.close();
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal('error.' + err.data.message);
        }
        defer.reject();
      })
  }

  internalDelivery() {
    if ((this.shipmentData.status === 'shipment.bagout' || this.shipmentData.status === 'shipment.deposited') || (this.shipmentData.shiptypeId === "BULKCASH" && this.shipmentData.bagSeal !== null)) {
      this.model.errorMsg = this.$translate.instant('error.internal_delivery_not_display', {
        bagSeal: this.shipmentData.bagSeal
      })
      return this.Modal.errorModal(this.model.errorMsg);
    }
    const defer = this.$q.defer();
    this.Modal.internalDeliveryModal(this.shipmentData, ({ modal, comment, locationId, supervisorId }) => {
      this.ShipmentService.updateFromLocation(this.shipmentData.branchId, this.shipmentData.trackingId,
        locationId, supervisorId, comment)
        .then((data) => {
          delete this.msg;
          delete this.branchTransferMsg;
          delete this.updateTrackingIdMsg;
          defer.resolve();
          modal.close();
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal('error.' + err.data.message);
          }
          defer.reject();
        })
    }, ({ modal }) => {
      modal.close();
    })
    defer.promise.then(() => {
      return this.loadData()
    })
  }

  updateTrackingId() {
    if ((this.shipmentData.status === 'shipment.bagout' || this.shipmentData.status === 'shipment.deposited') || (this.shipmentData.shiptypeId === "BULKCASH" && this.shipmentData.bagSeal !== null)) {
      this.model.errorMsg = this.$translate.instant('error.tracking_id_not_display', {
        bagSeal: this.shipmentData.bagSeal
      })
      return this.Modal.errorModal(this.model.errorMsg);
    }
    this.Modal.updateShipmentTrackingId(this.shipmentData.trackingId, this.branchInfo.supervisorScan, ({ modal, newTrackingId, supervisorId }) => {
      this.ShipmentService.updateShipmentTrackingId(this.shipmentData.shipmentId, this.shipmentData.trackingId, newTrackingId, this.shipmentData.branchId)
        .then((res) => {
          this.model.search = newTrackingId; // set new trackingId
          this.loadData();  // reload data after edit trackingId
          this.updateTrackingIdMsg = this.$translate.instant('branch_mgmt.items.trackingIdUpdated');
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal('error.' + err.data.message)
          }
        })
      modal.close();
    }, this.customerId, ({ modal }) => {
      modal.close();
    })
  }

  redirectToLocation(locationId) {
    this.$state.go('location.edit', {
      id: locationId
    })
  }

  goToServiceHistory(e, locationId, params) {
    const obj = {
      locationId: locationId,
      isRedirected: true
    }

    let locationData = this.DataCounter.setData(obj);
    params.DataCounter = locationData;

    if (e.ctrlKey) {
      localStorage.setItem('DataCounter',JSON.stringify(locationData));
      const url = this.$state.href('branchManagement.locations',params);
      window.open(url,'_blank')

    } else {
      localStorage.setItem('DataCounter',JSON.stringify(locationData));
      this.$state.go('branchManagement.locations', params, { notify: false });
    }
  }

  goToRouteTab(e, data, params) {
    const obj = {
      routeId: data.routeId,
      vaultDate: data.pickupFlag && data.countCompletedAt ? this.DateUtil.getTZFormattedDate(data.pickupDate, this.model.timezone) : data.vaultDate,
      isRedirected: true
    }
    
    let routeData = this.DataCounter.setData(obj);
    params.DataCounter = routeData;

    if (e.ctrlKey) {
      localStorage.setItem('DataCounter', JSON.stringify(routeData));
      const url = this.$state.href('branchManagement.routes', params);
      window.open(url, '_blank')
    } else {
      localStorage.setItem('DataCounter', JSON.stringify(routeData));
      this.$state.go('branchManagement.routes', params, { notify: false });
    }
  }

  orderPackingUndo(shipment) {
    if (this.loading) return;
    this.loading = true;

    this.Modal.undoPackedOrder(shipment, ({ modal, supervisorId, deleteOrder, deletedReason, $scope }) => {
      this.ShipmentService.orderPackingUndo(this.shipmentData.branchId, shipment.shipmentId, supervisorId, deletedReason, deleteOrder)
        .then(() => {
          modal.close();
          this.loading = false;
          return this.loadData();
        })
        .catch((err) => {
          modal.close();
          if (err && err.data && err.data.message) {
            this.loading = false;
            this.Modal.errorModal('error.' + err.data.message);
          }
        })
    }, ({ modal }) => {
      if (modal) modal.close();
      this.loading = false;
    })
  }

  softDeleteShipment(shipment) {
    if (this.loading) return;
    this.loading = true;

    this.Modal.deletedReason(shipment, ({ supervisorId, reason, modal }) => {
      this.ShipmentService.softDeleteShipment(shipment.shipmentId, shipment.branchId, reason, supervisorId)
        .then(() => {
          modal.close();
          this.loading = false;
          const totals = this.DataCounter.getCounterForItemHold();
          if (totals > 0 && this.shipmentData.isOnHold) this.DataCounter.setCounterForItemHold(totals - 1);
          return this.loadData();
        })
        .catch((err) => {
          modal.close();
          if (err && err.data && err.data.message) {
            this.loading = false;
            this.Modal.errorModal('error.' + err.data.message);
          }
        })
    }, ({ modal }) => {
      if (modal) modal.close();
      this.loading = false;
    });
  }

  markAsDelivered(shipment) {
    if (this.loading) return;
    this.loading = true;

    this.Modal.markAsDelivered(shipment, this.branchInfo.currentVaultDate, this.branchInfo.timezone, ({ modal, supervisorId, comment, loadedAmount, date, time }) => {
      this.HoldService.shipmentDelivery(shipment.trackingId, shipment.routeId, supervisorId, comment, shipment.branchId,
                                        loadedAmount, date, time, this.branchInfo.timezone, shipment.orderType, shipment.amount)
        .then(() => {
          const totals = this.DataCounter.getCounterForItemHold();
          if (totals > 0 && this.shipmentData.isOnHold) this.DataCounter.setCounterForItemHold(totals - 1);
          modal.close();
          this.loadData(); // refresh data after shipment delivered  
        })
        .catch((err) => {
          modal.close();
          this.Modal.errorModal('error.' + err.data.message)
        })
        .finally(() => {
          this.loading = false;
        })
    }, ({ modal }) => {
      if (modal) modal.close();
      this.loading = false;
    })
  }

  changeDestination() {
    if (this.validateShpDestination) return;
    this.validateShpDestination = true;

    this.Modal.changeDestinationModal(this.shipmentData, this.customerId, ({ modal, comment, locationId, supervisorId }) => {
      this.ShipmentService.changeDestination(this.shipmentData.trackingId, this.shipmentData.branchId, this.shipmentData.routeId, locationId, comment)
        .then(() => {
          delete this.msg;
          delete this.branchTransferMsg;
          delete this.updateTrackingIdMsg;
          delete this.shipmentDeliveredMsg;
          this.loadData();
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
        })
        .finally(() => {
          modal.close();
          this.validateShpDestination = false;
        })
    }, ({ modal }) => {
      if (modal) modal.close();
      this.validateShpDestination = false;
    })
  }

  redirectToATM(item) {
    return this.Navigation.goToAtmCount(item.trackingId, true, null, item.fundingSourceId)
  }
  
  validateOrderPackingUndo() {
    let shipmentPackedDate, branchCurrentVaultDate;
    
    if (this.shipmentData && this.shipmentData.fundingSourceId && this.shipmentData.unpackAnyTime) {
      this.isAllowedToUnpack = true;
    }
    else if (this.shipmentData.fundingSourceId && !this.shipmentData.unpackAnyTime) {
      shipmentPackedDate = new Date(this.shipmentData.packedDate);
      branchCurrentVaultDate = new Date(this.branchInfo.currentVaultDate);
      this.isAllowedToUnpack = shipmentPackedDate.getUTCDate() === branchCurrentVaultDate.getUTCDate();
    }
    else {
      this.isAllowedToUnpack = true;
    }
  }

  markAsCheckedIn(shipment) {
    this.Modal.confirmSupervisor('mark-as-checked-in', shipment.trackingId, ({ modal, supId }) => {
      this.HoldService.shipmentHoldMarkCheckedIn(shipment.trackingId, supId, shipment.branchId, shipment.routeId)
        .then(() => {
          modal.close();
          this.loadData();
        })
        .catch((err) => {
          modal.close();
          if (err && err.data && err.data.message) {
            return this.Modal.errorModal('error.' + err.data.message);
          }
        })
    }, ({ modal }) => {
       modal.close();
    })
  }

  translateItemStatus(status, orderNo, denominationId) {
      if(!status) return;
      else if(status === 'shipment.bagout' && orderNo && denominationId) return this.$translate.instant('branch_mgmt.items.childResidual');
      else if(status.startsWith('shipment')) return this.$translate.instant(status);
      else if(status.startsWith('CANT')) return this.$translate.instant(`shipment.${status}`)
      else return;
  }

  goToDVB(data) {
    const obj = {
      fundingSourceId: data.fundingSourceId,
      vaultDate: data.vaultDate,
      isRedirected: true
    }
    this.DataCounter.setData(obj);
    this.$state.go('branchManagement.dailyBalanceSheet');
  }

  showReceipt(shipments, stats) {
    document.getElementById('shipment-image').blur();
    let shipmentCopy = Object.assign({}, shipments);
    if (shipmentCopy.tranType === 'BAGOUT' && this.shipmentData.isBagoutDelivered) {
      shipmentCopy.deliveryImageName = this.shipmentData.bagoutDeliveryImageName;
    }
    this.Modal.shipmentImageModal(shipmentCopy, this.model.search, stats, ({ modal }) => {
    }, ({ modal }) => {
      modal.close();
    });
  }

  // findVaultDate(transactionCreatedAt) {
  //   if (this.model.vaultCloseDetails) {
  //     let transactionDate = moment.utc(transactionCreatedAt).valueOf();
  //     let vaultCloseTime = moment.utc(this.model.vaultCloseDetails.createdAt).valueOf();
  //     if (moment(transactionDate).isAfter(vaultCloseTime)) {
  //       return moment.utc(this.shipmentData.date).add(1, 'd').format('YYYY-MM-DD');
  //     }
  //     else if (moment(transactionDate).isBefore(vaultCloseTime)) {
  //       return moment.utc(this.shipmentData.date).format('YYYY-MM-DD');
  //     }
  //   }
  //   else {
  //     return moment.utc(this.shipmentData.date).format('YYYY-MM-DD');
  //   }
  // }

  allowInternalDelivery(locationType) {
     const locationTypeList = ['REGULAR', 'DELIVERY', 'NO_SHIP_NO_GO', 'BANK', 'ATM', 'INTERNAL', 'ON_CALL'];
     return locationTypeList.indexOf(locationType) > -1;
  }

  makeDeliverable() {
    this.Modal.makeDeliverable(this.shipmentData, ({ modal, routeId, vaultDate }) => {
      this.ShipmentService.makeDeliverable(this.shipmentData.trackingId, routeId, vaultDate, this.loggedInUser, this.shipmentData.branchId)
        .then(() => {
          this.loadData();
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal('error.' + err.data.message)
          }
        })
        .finally(() => {
          modal.close();
        })
    }, ({ modal }) => {
      modal.close();
    })
  }

  printShipment(records, type) {
    this.model.isPrint = true;
    this.ShipmentService.printStopReceipt(this.shipmentData.trackingId, this.selectedDepositAmountValue)
      .then((data) => {
        const shipments = data.reportData;
        let totalPickups = 0, totalDeliveries = 0;
        totalPickups = records && records.tranType === 'PICKUP' ? 1 : 0;
        totalDeliveries = records && (records.tranType === 'DELIVERY' || records.tranType === 'BAGOUT') ? 1 : 0;
        let stopDateTime = records.transactionDate ? moment(records.transactionDate).tz(this.model.timezone).format('MM/DD/YYYY hh:mm:ss A Z') : 'N/A';
        let url = this.$state.href('branchMgmtPrintStopReceipt');

        window.w = window.open(url, '_blank');
        window.w.printData = {
          shipmentRecords: records,
          results: data.reportData,
          envConfigResults: data.envConfigData,
          totalPickups, totalDeliveries, stopDateTime
        };
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.isPrint = false;
      })
  }

  sendDeliveryOrPickupReceipt(stat) {
    const formattedDate = this.DateUtil.getUTCDate(this.shipmentData.vaultDate),
          trackingId = this.shipmentData.trackingId,
          locationId = stat === 'delivery' ? this.shipmentData.toLocationId : this.shipmentData.fromLocationId,
          branchId = this.shipmentData.branchId,
          routeId = (stat === 'delivery' && this.shipmentData.individuallyDeliverable && this.shipmentData.individuallyDeliverableRouteId) ? this.shipmentData.individuallyDeliverableRouteId : this.shipmentData.routeId,
          locationEmail = stat === 'delivery' && this.shipmentData.toLocationEmail ? this.shipmentData.toLocationEmail : 
                          stat === 'pickup' && this.shipmentData.fromLocationEmail ? this.shipmentData.fromLocationEmail : null;

    this.Modal.sendStopReceipt(locationEmail, ({ modal, providedEmail, $scope }) => {
      this.LocationService.sendDeliveryOrPickupReceipt(trackingId, locationId, branchId, routeId, formattedDate, providedEmail, this.selectedDepositAmountValue, this.model.timezone, stat.toUpperCase())
        .then(() => { })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message)
          }
        })
        .finally(() => {
          modal.close();
          $scope.model.loading = false;
        })
    }, ({ modal }) => {
      if(modal) modal.close();
    })
  }

  changeShiptype() {
    if ((this.shipmentData.status === 'shipment.bagout' || this.shipmentData.status === 'shipment.deposited') || (this.shipmentData.shiptypeId === "BULKCASH" && this.shipmentData.bagSeal !== null)) {
      this.model.errorMsg = this.$translate.instant('error.branch_mgmt_shiptype_not_display', {
        bagSeal: this.shipmentData.bagSeal
      })
      return this.Modal.errorModal(this.model.errorMsg);
    }

    this.Modal.changeShiptypeId(this.shipmentData, this.customerId, ({ modal, shiptype, supervisorId }) => {
      this.ShipmentService.changeShiptype(this.shipmentData.trackingId, this.shipmentData.branchId, shiptype)
        .then((res) => {
          this.loadData();  // reload data after edit shiptypeid
        })
        .catch((err) => {
          if (err && err.data && err.data.message) {
            this.Modal.errorModal(err.data.message);
          }
        })
        .finally(() => {
          modal.close();
        })
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  getSoftDeleteShipmentPermission() {
    this.UsersService.validateUserPermissions(this.User.getUser().firstName, this.User.getUser().lastName)
      .then((permissions) => {
        let softDeletePerm = (permissions.hasSoftDeleteShipmentPermission || this.CommonLayoutService.isAllowToAccessPages());
        if (this.User.getUser().customerUser) {
          const aclList = this.User.getACL('branch_mgmt_items') || [];
          this.hasSoftDeleteShipmentPermission = aclList.includes('edit');
        } else {
          this.hasSoftDeleteShipmentPermission = softDeletePerm;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  translateTranType(type) {
    if (!type) return;

    if (['HOLD', 'BAGOUT'].includes(type)) return this.$translate.instant(`shipment.${type.toLowerCase()}`).toUpperCase()
    else return this.$translate.instant(`shipment.${type}`).toUpperCase()
  }

  formatAmount(amount) {
    let formatted = amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return formatted;
  }

  isShipmentCounted() {
    return this.shipmentData && this.shipmentData.countCompletedAt;
  }

  convertToCrv(shipment) {
    if (this.loading) return;
    this.loading = true;

    this.UsersService.checkSupervisor(this.loggedInUser)
      .then((userInfo) => {
        this.Modal.convertToCrv(shipment, !userInfo.supervisor, true, ({ supervisor, trackingIdResidual, modal }) => {
          if (trackingIdResidual) {
            const defer = this.$q.defer();
            this.HoldService.convertToCRV(this.model.branch, shipment.trackingId, trackingIdResidual, userInfo.supervisor ? userInfo.id : supervisor)
              .then((data) => {
                modal.close();
                defer.resolve(data);
              })
              .catch((err) => {
                modal.close();
                if (err && err.data && err.data.message) {
                  this.loading = false;
                  this.Modal.errorModal('error.' + err.data.message);
                }
              });

            defer.promise.then(() => {
              this.loading = false;
              this.loadData();
            });
          } else {
            if (modal) modal.close();
            this.loading = false;
          }
        }, ({ modal }) => {
          if (modal) modal.close();
          this.loading = false;
        });
      })
      .catch((err) => {
        this.loading = false;
        this.Modal.errorModal(err.data && err.data.message ? err.data.message : err);
      });
  }

  convertToCrvPackableOrder(shipment) {
    if (this.loading) return;
    this.loading = true;

    this.Modal.confirm({
      header: 'Confirm CRV Conversion',
      message: 'Are you sure you want to convert this Shipment to CRV?',
      callback: ({ modal }) => {
        modal.close();
        this.UsersService.checkSupervisor(this.loggedInUser)
          .then((userInfo) => {
            this.Modal.confirmSupervisor('shipment-hold-convert-CRV', { trackingId: shipment.trackingId }, ({ modal: supModal, supId }) => {
              supModal.close();
              const defer = this.$q.defer();
              this.HoldService.convertToCrvPackableOrder(this.model.branch, shipment.trackingId, shipment.packableOrderShipmentId, supId)
                .then((data) => {
                  defer.resolve(data);
                })
                .catch((err) => {
                  if (err && err.data && err.data.message) {
                    this.loading = false;
                    this.Modal.errorModal('error.' + err.data.message);
                  }
                });

              defer.promise.then(() => {
                this.loading = false;
                this.loadData();
              });
            }, ({ modal: supModal }) => {
              supModal.close();
              this.loading = false;
            });
          })
          .catch((err) => {
            this.loading = false;
            this.Modal.errorModal(err.data && err.data.message ? err.data.message : err);
          });
      },
      negative: ({ modal }) => {
        modal.close();
        this.loading = false;
      }
    }, ({ modal }) => {
      if (modal) modal.close();
      this.loading = false;
    });
  }

  convertShipmentToCrv() {
    const shipment = this.shipmentData;
    if (!shipment || !shipment.packedFlag || shipment.checkedOut) return;

    if (shipment.packableOrderShipmentId) {
      return this.convertToCrvPackableOrder(shipment);
    }

    return this.convertToCrv(shipment);
  }

}

export default ItemsController; 



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/items/items.controller.js